export const locale = {
    lang: "en",
    data: {
        DASHBOARD: {
            Title: "Control Center",
            SwitchViews: "Cambiar Vista",
            Done: "Done",
            EventStream: "Eventos",
            KioskMode: "Kiosk Mode",
            KioskModeMessage: "Kiosk Mode works better on FullScreen, do you want to go FullScreen?",
        },
        DEVICES: {
            ConnectedDevices: "Connected Devices",
            Connected: "Connected",
            Total: "Total",
        },
        FIELD: {
            sound_pressure_level: "Sound Pressure (dBA)",
            sound_pressure_level_c: "Sound Pressure (dBC)",
            sound_pressure_level_1m: "Sound Pressure (dBA, 1 min)",
            sound_pressure_level_1m_sensor_2: "Sound Pressure (Sensor 2)",
            sound_pressure_level_c_1m: "Sound Pressure (dBC, 1 min)",
            sound_pressure_level_c_minus_a: "dBC - dBA",
            rolling_5s: "Rolling 5 seconds (dBA)",
            rolling_5s_c: "Rolling 5 seconds (dBC)",
            rolling_5: "Rolling 5 minutes (dBA)",
            rolling_5_c: "Rolling 5 minutes (dBC)",
            rolling_30: "Rolling 30 minutes (dBA)",
            rolling_30_c: "Rolling 30 minutes (dBC)",
            battery: "Battery",
            power_supply_status: "Power Supply",
            spectrum_13_octave: "1/3 Octave Spectrum",
            spectrum_13_octave_1m: "1/3 Octave Spectrum (1 min)",
            temperature: "Ext. Temperature",
            overload: "Overload",
            underrange: "Underrange",
            wifi_signal_level: "WiFi Signal",
            cellullar_signal_level: "Cellular Signal",
            free_storage: "Free Storage",
        },
        SIDEBAR: {
            Views: "Views",
            Delete: "Are you sure you want to delete ?",
            AddView: "Add View",
        },
    },
};
